// Type definitions
export const FormFieldTypes = Object.freeze({
  date: "date",
  bool: "bool",
  enum: "enum",
  json: "json",
  object: "object",
});

export const ResourceCategory = Object.freeze({
  official: "Official",
  personal: "Personal",
  test: "Test",
  undefined: "Undefined",
});

export const ResourceStates = Object.freeze({
  created: "Created",
  active: "Active",
  actionRequired: "ActionRequired",
  inactive: "Inactive",
  blocked: "Blocked",
  archived: "Archived",
  deleted: "Deleted",
});

export const UNSUBSCRIBE_WARNINGS = {};

export const HIDE_DELETE_BUTTON = Object.freeze({
  Resources: ["OpenstackProject", "RegistryProject"],
});

export const HIDE_CHANGE_ADMINISTRATOR_GROUP_BUTTON = Object.freeze({
  Resources: ["teams", "Teams", "Groups365", "SharePoint", "OracleAccount"],
});
